const path = require('path')

const router = require('../../router')


module.exports = async(graphql, actions, route) => {
  const { createPage } = actions
  const gameContainer = path.resolve('src/containers/Game/index.js')

  return createPage({
    path: router(route.path),
    component: gameContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
